import { Dispatch, SetStateAction, useEffect, useState } from "react";

import { useAuth } from '@core/features-core/auth/client';
import { makeGetAllBookmarkContentUseCase } from "@mais-retorno-front/core-business";

interface IUseBookmarkContentResponse {
  bookmarksIds: string[];
  setBookmarksIds: Dispatch<SetStateAction<string[]>>
}

export const useBookmarkContent = (): IUseBookmarkContentResponse => {
  const [bookmarksIds, setBookmarksIds] = useState<string[]>([]);

  const { initialized, userIsLogged } = useAuth();

  const getAllBookmarkContentUseCase = makeGetAllBookmarkContentUseCase();

  useEffect(() => {
    if (!initialized || !userIsLogged) return;

    async function loadBookmarksContent() {
      const { bookmarksIds: userBookmarksIds, error } = await getAllBookmarkContentUseCase.handle();
      
      if (!error) setBookmarksIds(userBookmarksIds);
    }

    loadBookmarksContent();
  }, [initialized, userIsLogged]);

  return {
    bookmarksIds,
    setBookmarksIds
  }
}